import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import serviceData from "../../Data/serviceData";
import ContactForm from "../../components/ContactForm";

const SeviceDetails = () => {
  const { id } = useParams();

  const [services, setServices] = useState([]);

  useEffect(() => {
    setServices(serviceData);
  }, []);

  const item = services.find((i) => i.id === Number(id));

  return (
    <div>
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/image/clean7.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "350px", // or any desired height
          display: "flex",
          alignItems: "flex-end", // this pushes content to the bottom
          paddingBottom: "30px", // space from bottom edge
        }}
      >
        <div className="container mt-5">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">{item && item.title}</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                {item && item.category === "Cleaning"
                  ? "Cleaning"
                  : "Pest Control"}
                &nbsp; SERVICE DETAILS
              </li>
            </ul>
          </div>
        </div>
      </div>

      <section className="space-top space-extra2-bottom">
        <div className="container">
          <div className="title-area text-center">
            <span className="sub-title6 justify-content-center">
              <span className="shape left">
                <span className="dots"></span>
              </span>
              SERVICE DETAILS
              <span className="shape right">
                <span className="dots"></span>
              </span>
            </span>
            <h2 className="sec-title">{item && item.title}</h2>
          </div>

          <div className="row">
            <div className="col-xxl-8 col-lg-8">
              <div className="page-single">
                <div className="page-content">
                  <h2 className="h3 page-title">{item && item.subTitle}</h2>
                  <p className="mb-30">{item && item.description1}</p>

                  <div className="row gy-30 align-items-center mb-30">
                    <div className="col-xl-6">
                      <div className="page-img">
                        <img
                          className="w-100"
                          src={item && item.icon}
                          alt="Service Imagee"
                          style={{ height: "280px" }}
                        />
                      </div>
                    </div>

                    <div className="col-xl-6">
                      <h3 className="h5 mt-30">
                        {item && item.category === "Cleaning"
                          ? "Source of Dirt & Grime"
                          : "Pest Infestation Sources"}
                      </h3>
                      <p>{item && item.description2}</p>
                    </div>
                  </div>

                  <h3 className="h5 mt-30">
                    {item && item.category === "Cleaning"
                      ? "Impact of a Dirty Environment"
                      : "Effects of Pests on Health & Property"}
                  </h3>
                  <p className="mb-30">{item && item.description3}</p>

                  <h3 className="h5 mt-30">
                    {item && item.category === "Cleaning"
                      ? "Our Cleaning Solutions"
                      : "Effective Pest Control Methods"}
                  </h3>
                  <p className="mb-30">{item && item.description4}</p>

                  <h3 className="h5 mt-30">Interesting Fact</h3>
                  <p className="mb-30">{item && item.description5}</p>

                  <h2 className="h3 page-title mb-5">How do we work?</h2>
                  <div className="row gy-40 justify-content-between">
                    <div className="col-sm-6 col-lg-auto process-card2-wrap">
                      <div className="process-card2">
                        <div className="process-card2_icon">
                          <i className="fal fa-file-signature"></i>
                        </div>
                        <h2 className="process-card2_title">Request</h2>
                        <p className="process-card2_text">
                          Submit the form and we’ll contact you quickly.
                        </p>
                      </div>
                    </div>

                    <div className="col-sm-6 col-lg-auto process-card2-wrap">
                      <div className="process-card2">
                        <div className="process-card2_icon">
                          <i className="fal fa-calendar-check"></i>
                        </div>
                        <h2 className="process-card2_title">Arrival</h2>
                        <p className="process-card2_text">
                          Our team arrives right on schedule.
                        </p>
                      </div>
                    </div>

                    <div className="col-sm-6 col-lg-auto process-card2-wrap">
                      <div className="process-card2">
                        <div className="process-card2_icon">
                          <i className="fal fa-search-location"></i>
                        </div>
                        <h2 className="process-card2_title">Inspect</h2>
                        <p className="process-card2_text">
                          We assess the area before starting.
                        </p>
                      </div>
                    </div>

                    <div className="col-sm-6 col-lg-auto process-card2-wrap">
                      <div className="process-card2">
                        <div className="process-card2_icon">
                          <i className="fal fa-file-contract"></i>
                        </div>
                        <h2 className="process-card2_title">Contract</h2>
                        <p className="process-card2_text">
                          We sign the service agreement with you.
                        </p>
                      </div>
                    </div>

                    <div className="col-sm-6 col-lg-auto process-card2-wrap">
                      <div className="process-card2">
                        <div className="process-card2_icon">
                          <i className="fal fa-tools"></i>
                        </div>
                        <h2 className="process-card2_title">Process</h2>
                        <p className="process-card2_text">
                          Work begins immediately after agreement.
                        </p>
                      </div>
                    </div>

                    <div className="col-sm-6 col-lg-auto process-card2-wrap">
                      <div className="process-card2">
                        <div className="process-card2_icon">
                          <i className="fal fa-stopwatch"></i>
                        </div>
                        <h2 className="process-card2_title">Finish</h2>
                        <p className="process-card2_text">
                          Everything is completed within 40 minutes.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xxl-4 col-lg-4">
              <aside className="sidebar-area">
                <div className="widget widget_categories  ">
                  <h3 className="widget_title">All Services</h3>
                  <ul>
                    {services.map((hh) => {
                      return (
                        <li key={hh.id}>
                          <Link
                            to={`/service/service-details/${hh.id}`}
                            style={{
                              color: item.id === hh.id ? "#F95E14" : "",
                            }}
                          >
                            {hh.title}
                          </Link>
                          {/* <span>(08)</span> */}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>

      <ContactForm />
    </div>
  );
};

export default SeviceDetails;
